module.exports = __webpack_public_path__ + "static/media/Maax-Regular.68a0ba14.eot";